import React, { useEffect } from "react";
import { Box, Button, CardMedia, CircularProgress, Grid, Table, TableBody, TableCell, TableContainer, TableRow, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import { styled } from "@mui/material/styles";
import { Link, useParams } from "react-router-dom";
import { ButtonBack, ButtonFirst, ButtonLast, ButtonNext, CarouselProvider, Slide, Slider } from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';
import moment from "moment";
import { saveAs } from 'file-saver';
import { connect } from "react-redux";
import MainCard from "ui-component/cards/MainCard";
import SubCard from "ui-component/cards/SubCard";
import { farmRecordDetailsErrorClear, getFarmRecordDetails, } from "store/app/farm-management/farm-records/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { IconDownload } from "@tabler/icons-react";
import Chip from "ui-component/extended/Chip";
import { IconClipboardText } from "@tabler/icons-react";
import {
    IconChevronLeft,
    IconChevronRight,
    IconChevronsLeft,
    IconChevronsRight,
    IconEggCracked,
    IconExternalLink,
    IconFlask,
    IconListCheck,
    IconMoodEmpty,
    IconPinned,
} from "@tabler/icons-react";
// import "./style.css";

// Styled components
const StyledSlide = styled(Slide)`
  .focusRing___1airF.carousel__slide-focus-ring {
    outline: none !important;
  }
`;

const carButton = {
    backgroundColor: "white",
    border: "none",
}

const FarmRecordDetails = (props) => {
    const { errorMessage, isPending, resetPasswordErrorMessage, farmRecordDetails } = props;
    const { recordsIndex, recordStatus, farmName, technicalManagerUserName, technicalManagerUserEmail, customerName, customerEmail, inspectionDate, submittedTimeStamp,
        location, regionName, stateName, age, examinedBirdsCount, anticoccidial, agp, probiotic, birdsRecord, isLabReportAvailable, districtName, remark } = farmRecordDetails || {};
    const { farmRecordSummaryResult } = farmRecordDetails || [];
    const params = useParams();
    const { id } = params || {};
    const { apiUrl } = window.__ENV || {};

    useEffect(() => {
        props.getFarmRecordDetails(id);
        props.farmRecordDetailsErrorClear();
    }, [id])

    const theme = useTheme();

    const handleDownLoadImage = async (imgURL, name) => {
        const response = await fetch(imgURL);
        const blob = await response.blob();
        saveAs(blob, name)
    }

    const FormulaChip = () => {
        return (
            < sup
                style={{
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.main,
                    borderRadius: "20px",
                    fontWeight: "bold",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    marginLeft: "2px"
                }}
            >
                Formula
            </sup >
        )
    }

    const valueNamingConverter = (value) => {
        switch (value?.toLowerCase()) {
            case "yes":
                return "Present";
            case "no":
                return "Absent";
            default:
                return value;
        }
    }

    return (
        <>
            <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SubCard sx={{ p: 1.5, pl: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h4">Farm Record Details</Typography>
                    </SubCard>
                </Grid>
                {errorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={errorMessage} />
                    </Grid>
                }
                {resetPasswordErrorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={`Reset Password: ${resetPasswordErrorMessage}`} />
                    </Grid>
                }
            </Grid>
            {isPending ?
                <Grid container alignItems={"center"} justifyContent={"center"} gap={1}>
                    <CircularProgress />
                    <Typography variant="h5" color={'primary'}> Loading...</Typography>
                </Grid>
                :
                <Grid container>
                    <Grid item lg={5} md={12} sm={12} xs={12}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconListCheck color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Farm Info
                                </Typography>
                            </Grid>
                            <TableContainer sx={{ pl: 3, }}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Farm Record No.</TableCell>
                                            <TableCell>{recordsIndex || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Farm Record Status</TableCell>
                                            <TableCell>{recordStatus || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Farm Name</TableCell>
                                            <TableCell>{farmName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Technical Manager Name</TableCell>
                                            <TableCell>{technicalManagerUserName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Technical Manager Email</TableCell>
                                            <TableCell>{technicalManagerUserEmail || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Customer Name</TableCell>
                                            <TableCell>{customerName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Customer Email</TableCell>
                                            <TableCell>{customerEmail || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Inspection Date</TableCell>
                                            <TableCell>{inspectionDate ? moment(inspectionDate).format("DD MMM YYYY") : "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Submitted Date</TableCell>
                                            <TableCell>{submittedTimeStamp ? moment(submittedTimeStamp).format("DD MMM YYYY") : "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> Location</TableCell>
                                            <TableCell>{location || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> Region Name</TableCell>
                                            <TableCell>{regionName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> State/Export</TableCell>
                                            <TableCell>{stateName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> District</TableCell>
                                            <TableCell>{districtName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> Age</TableCell>
                                            <TableCell>{age || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Anticoccidial</TableCell>
                                            <TableCell>{anticoccidial || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>AGP</TableCell>
                                            <TableCell>{agp || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Probiotic</TableCell>
                                            <TableCell>{probiotic || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Remark</TableCell>
                                            <TableCell>{remark || "N/A"}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid item sx={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                <IconClipboardText color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Record Summary
                                </Typography>
                            </Grid>
                            <TableContainer sx={{ pl: 3, }}>
                                <Table size="small">
                                    <TableBody>
                                        {farmRecordSummaryResult?.length > 0 ?
                                            farmRecordSummaryResult?.map((summary, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{summary.reportName}</TableCell>
                                                    <TableCell>{summary.reportValue}</TableCell>
                                                </TableRow>
                                            )) : ""}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                    <IconFlask color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Lab Report Info
                                    </Typography>
                                </Grid>
                                {isLabReportAvailable &&
                                    <Grid item>
                                        <Link to={`/farm-records/lab-records/${recordsIndex}`}>
                                            <Chip
                                                label={<div style={{
                                                    // color: "black",
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: "8px",
                                                    textDecoration: "none"
                                                }}>
                                                    <IconExternalLink />
                                                    <Typography variant="h5" color="inherit">
                                                        View More
                                                    </Typography>
                                                </div>}
                                            />
                                        </Link>
                                    </Grid>}
                            </Grid>
                            <TableContainer sx={{ pl: 3, }}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Lab Report</TableCell>
                                            <TableCell>{isLabReportAvailable ?
                                                <Chip
                                                    label="Available"
                                                    chipcolor="success"
                                                    size="small"
                                                /> :
                                                <Chip
                                                    label="Unavailable"
                                                    chipcolor="error"
                                                    size="small"
                                                />}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                    </Grid>
                    <Grid item lg={7} md={12} sm={12} xs={12}>
                        <Grid item>
                            <MainCard sx={{ mt: 1, ml: 1 }}>
                                <Grid container gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <IconEggCracked color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Birds Records -
                                        <Tooltip title="Examined Birds Count" placement="top">
                                            <span>
                                                <Chip
                                                    label={`${examinedBirdsCount}`}
                                                    chipcolor="secondary"
                                                    size="small"
                                                    sx={{
                                                        borderRadius: "20%",
                                                        py: 1,
                                                        fontWeight: "bold",
                                                        fontSize: 15,
                                                        cursor: "pointer"
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                    </Typography>
                                </Grid>
                                <CarouselProvider
                                    naturalSlideWidth={100}
                                    naturalSlideHeight={70}
                                    totalSlides={examinedBirdsCount}
                                    dragEnabled={false}
                                    isIntrinsicHeight={true}
                                >
                                    <Slider
                                        style={{
                                            boxShadow: "rgba(100, 100, 111, 0.2 ) 0px 7px 29px 0px",
                                            margin: "10px",
                                            borderRadius: "10px",
                                        }
                                        }>
                                        {birdsRecord?.map((data, index) => (
                                            <StyledSlide key={index} index={index}>
                                                <Grid container>
                                                    <Grid item lg={12} md={12} sm={12} xs={12}
                                                        sx={{
                                                            bgcolor: theme.palette.secondary.main,
                                                            p: 1,
                                                            px: 1,
                                                            width: "100%",
                                                            textAlign: "center"
                                                        }}>
                                                        <Typography variant="h5" color="white">
                                                            {data.birdNo} out of {examinedBirdsCount}
                                                        </Typography>
                                                    </Grid>

                                                </Grid>
                                                <Grid container direction={"row"} marginTop={1}>
                                                    {data?.imageLst?.length ?
                                                        <Grid item lg={6} md={6} sm={6} xs={12}>
                                                            <CarouselProvider
                                                                naturalSlideWidth={100}
                                                                naturalSlideHeight={180}
                                                                totalSlides={data?.imageLst?.length}
                                                                dragEnabled={false}
                                                            // isIntrinsicHeight={true}
                                                            >
                                                                <Grid container justifyContent={"center"} alignItems={"center"} sx={{ mb: 1 }}>
                                                                    <Typography variant="h5">
                                                                        Gut & Organ Images
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid container alignItems={"center"} justifyContent={"center"}>
                                                                    <Grid item lg={1} md={1} sm={1} xs={1} sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <ButtonBack
                                                                            style={{ ...carButton, padding: "0px" }}
                                                                        >
                                                                            <IconChevronLeft />
                                                                        </ButtonBack>
                                                                    </Grid>
                                                                    <Grid item lg={10} md={10} sm={10} xs={10}>
                                                                        <Slider>
                                                                            {data?.imageLst?.length > 0 &&
                                                                                data.imageLst?.map((img, index) => {
                                                                                    const imgSrc = `${apiUrl}/api/FarmRecords/GetImage?FileName=${encodeURIComponent(img.fileName)}&RecordId=${id}&BirdNo=${img.birdNo}`;
                                                                                    return (
                                                                                        <Slide
                                                                                            key={index}
                                                                                            index={index}
                                                                                            style={{
                                                                                                maxHeight: "500px",
                                                                                                overflow: "auto",
                                                                                            }}
                                                                                        >
                                                                                            <Grid container justifyContent={"center"}>
                                                                                                <Grid item lg={12} md={12} sx={{
                                                                                                    position: "relative",
                                                                                                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                                                                                                    borderRadius: "10px",
                                                                                                    margin: "10px",
                                                                                                }}>
                                                                                                    <CardMedia
                                                                                                        component={"img"}
                                                                                                        alt="Image Not Found"
                                                                                                        image={imgSrc}
                                                                                                        sx={{
                                                                                                            objectFit: "contain",
                                                                                                            height: "300px",
                                                                                                            width: "auto",
                                                                                                            px: 0.5,
                                                                                                            mt: 1
                                                                                                        }}
                                                                                                    />
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            position: "absolute",
                                                                                                            top: 8,
                                                                                                            right: 8,
                                                                                                            backgroundColor: "rgba(0,0,0,0.6)",
                                                                                                            color: "white",
                                                                                                            px: 1.5,
                                                                                                            py: 0.5,
                                                                                                            borderRadius: "12px",
                                                                                                            fontSize: "12px",
                                                                                                            fontWeight: "bold",
                                                                                                        }}
                                                                                                    >
                                                                                                        {`${index + 1} / ${data?.imageLst?.length}`}
                                                                                                    </Box>
                                                                                                </Grid>
                                                                                                <Grid item lg={12} md={12} sm={12} >
                                                                                                    <Tooltip title="Download" placement="top">
                                                                                                        <Button
                                                                                                            sx={{ float: "right", p: 0 }}
                                                                                                            size="small"
                                                                                                            onClick={() => handleDownLoadImage(imgSrc, img.fileName)}
                                                                                                        >
                                                                                                            <IconDownload />
                                                                                                        </Button>
                                                                                                    </Tooltip>
                                                                                                    <Table size="small">
                                                                                                        <TableBody>
                                                                                                            <TableRow>
                                                                                                                <TableCell
                                                                                                                    sx={{
                                                                                                                        color: theme.palette.secondary.main,
                                                                                                                        fontWeight: "bold",
                                                                                                                        border: "none",
                                                                                                                        pt: 0,
                                                                                                                    }}
                                                                                                                >
                                                                                                                    Organ Name
                                                                                                                </TableCell>
                                                                                                                <TableCell
                                                                                                                    sx={{
                                                                                                                        border: "none",
                                                                                                                        color: theme.palette.primary.main
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {img.organName || "N/A"}
                                                                                                                </TableCell>
                                                                                                            </TableRow>
                                                                                                            <TableRow>
                                                                                                                <TableCell
                                                                                                                    sx={{
                                                                                                                        border: "none",
                                                                                                                        color: theme.palette.secondary.main,
                                                                                                                        fontWeight: "bold"
                                                                                                                    }}
                                                                                                                >
                                                                                                                    Comments
                                                                                                                </TableCell>
                                                                                                                <TableCell
                                                                                                                    sx={{
                                                                                                                        border: "none",
                                                                                                                        textAlign: "justify",
                                                                                                                        color: theme.palette.primary.main
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {img.comments || "N/A"}
                                                                                                                </TableCell>
                                                                                                            </TableRow>
                                                                                                        </TableBody>
                                                                                                    </Table>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </Slide>
                                                                                    )
                                                                                })}
                                                                        </Slider>
                                                                    </Grid>
                                                                    <Grid item lg={1} md={1} sm={1} xs={1} sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <ButtonNext
                                                                            style={{ ...carButton, padding: "0px" }}
                                                                        >
                                                                            <IconChevronRight />
                                                                        </ButtonNext>
                                                                    </Grid>
                                                                </Grid>
                                                            </CarouselProvider>
                                                        </Grid>
                                                        : ""}
                                                    <Grid item lg={data?.imageLst?.length > 0 ? 6 : 12} md={data?.imageLst?.length > 0 ? 6 : 12} sm={data?.imageLst?.length > 0 ? 6 : 12} xs={12} >
                                                        <TableContainer sx={{ overflow: "auto", maxHeight: "fit-content" }}>
                                                            <Table size="small">
                                                                <TableBody>
                                                                    {data.formRecordValues?.length > 0 ? data.formRecordValues?.map((data, index) => (
                                                                        < TableRow key={index}>
                                                                            <TableCell sx={{ border: "none" }}>
                                                                                <Grid container direction={"row"} alignItems={"center"} gap={1}>
                                                                                    <Grid item lg={1} md={1} sm={1}>
                                                                                        <IconPinned color={theme.palette.secondary.main} />
                                                                                    </Grid>
                                                                                    <Grid item lg={10} md={10} sm={10}>
                                                                                        <Typography color={theme.palette.primary.main}>
                                                                                            {data.fieldName || "N/A"}
                                                                                            {data.dataType === "formula" && <FormulaChip />}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </TableCell>
                                                                            <TableCell sx={{ border: "none", color: theme.palette.primary.main }}>
                                                                                {data.fieldValue ? valueNamingConverter(data.fieldValue) : "N/A"}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )) : <Grid container justifyContent="center" alignItems="center" direction="column" sx={{ minHeight: "300px" }}>
                                                                        <IconMoodEmpty color="red" />
                                                                        <Typography variant="h5" color="primary">
                                                                            Birds Record Not Available.
                                                                        </Typography>
                                                                    </Grid>
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </StyledSlide>
                                        ))}
                                    </Slider>
                                    {
                                        (birdsRecord?.length > 1) &&
                                        <>
                                            <Grid container justifyContent={"end"} gap={1}>
                                                <ButtonFirst style={{ ...carButton }}>
                                                    <IconChevronsLeft />
                                                </ButtonFirst>
                                                <ButtonBack style={{ ...carButton }}>
                                                    <IconChevronLeft />
                                                </ButtonBack>
                                                {/* <DotGroup
                                            style={{ ...carButton }}
                                            dotNumbers={true}
                                            showAsSelectedForCurrentSlideOnly={false}
                                        /> */}
                                                <ButtonNext style={{ ...carButton, }}>
                                                    <IconChevronRight />
                                                </ButtonNext>
                                                <ButtonLast style={{ ...carButton, }}>
                                                    <IconChevronsRight />
                                                </ButtonLast>
                                            </Grid>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                                align="end"
                                                sx={{ mt: 1, }}
                                            >
                                                Click the arrows to navigate across birds
                                            </Typography>
                                        </>
                                    }

                                </CarouselProvider>
                            </MainCard>
                        </Grid>
                    </Grid >
                </Grid >
            }
        </>
    )
}

const mapStateToProps = (state) => ({
    farmRecordDetails: state.farmRecords.farmRecordDetails,
    isPending: state.farmRecords.isFarmRecordDetailsPending,
    errorMessage: state.farmRecords.farmRecordDetailsErrorMessage,
})

const mapDispatchToProps = (dispatch) => ({
    getFarmRecordDetails: (id) => dispatch(getFarmRecordDetails(id)),
    farmRecordDetailsErrorClear: (id) => dispatch(farmRecordDetailsErrorClear(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FarmRecordDetails);